import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch} from "react-redux";
import {disbandUnionRequest, quitUnionClubRequest} from "../../../../store/actionCreators/union";

const DisbandUnion =({ unionId, isMember }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [id, setId] = useState('');
    const disbandUnion = () => {
        if( isMember ) {
            dispatch(quitUnionClubRequest(unionId));
        } else {
            dispatch(disbandUnionRequest(unionId));
        }
    };
    return (
        <div className={`disbandClub`}>
            <div className={`unionDisbandText`}>{isMember ? t('quitTheUnion') : t('disbandUnion')}</div>
            {/*<div className={`clubId`}>{t.unionId}: {unionId}</div>*/}
            <div className={`clubId`}>{isMember ? t('clubId') : t('unionId')}</div>
            <input type="number" placeholder={`Enter the Union ID`} onChange={ (e) => setId(e.target.value) }/>
            <div className={`dialogConfirmBox`}>
                <button className="primary" disabled = { id !== unionId } onClick={disbandUnion}>{t('button.confirm')}</button>
            </div>
        </div>
    );
};

export default DisbandUnion;
